export const isProd = process.env.NODE_ENV === 'production'
export const isDev = process.env.NODE_ENV === 'development'

export const isAnno = process.env.NEXT_PUBLIC_IS_ANNO !== undefined
